import React from 'react';
import { Container, Typography, Button, Box, Grid, Card, CardContent, Divider } from '@mui/material';
import styled from '@emotion/styled';
import Image from "../images/Untitled design (27).png";
import RankingsIcon from '../images/ranking.svg';  
import ExamsIcon from '../images/exam.svg';        

const categories = [
  {
    title: "Rankings",
    icon: RankingsIcon,
    description: "1500 Colleges Ranked based on transparent, accurate, government-approved, student-friendly data",
    items: [
      { name: "Top Engineering Colleges in India" },
      { name: "Top MBA Colleges in India" },
      { name: "Top Law Colleges in India" },
      { name: "Top Medical Colleges in India" },
      { name: "Top Universities in India" },
    ]
  },
  {
    title: "Exams",
    icon: ExamsIcon,
    description: "Easy Information and downloads on Exam preparation, dates, counselling, syllabus and more",
    items: [
      { name: "JEE Main" },
      { name: "GATE" },
      { name: "CAT" },
      { name: "CLAT" },
      { name: "NEET" },
      { name: "BITSAT" },
      { name: "SRMJEEE" },
      { name: "NIFT Entrance Exam" },
      { name: "VITEEE" },
      { name: "MET" },
      { name: "CUET" },
      { name: "LPU-NEST" },
    ]
  }
];

const AnimatedCard = styled(Card)`
  box-shadow: 0 8px 16px rgba(0, 0, 0, 0.6); 
  transition: transform 0.3s, box-shadow 0.3s;
  background: linear-gradient(135deg,#d1d9e6, #eceef4 ); 
  &:hover {
    transform: translateY(-10px);
    box-shadow: 0 12px 24px rgba(0, 0, 0, 0.7); 
  }
`;

const CustomCardContent = styled(CardContent)`
  padding: 16px;
  &:last-child {
    padding-bottom: 16px;
  }
`;

const CustomTypography = styled(Typography)`
  font-weight: bold;
  margin-left: 8px; 
`;

const CustomButton = styled(Button)`
  margin: 4px;
  border-radius: 20px;
  color: black; 
  border: 1px solid black; 
  &:hover {
    background-color: #233098;
    color: #fff;
    border-color: #233098;
  }
`;

const IconImage = styled('img')`
  width: 40px;
  height: 40px;
  margin-right: 8px;
`;

const App = () => {
  return (
    <Grid sx={{ width: '100%', backgroundColor: '#eceef4', height: { xs: 'auto', md: '900px' } }}>
      <Container maxWidth="lg" sx={{ marginTop: '40px' }}>
        <Grid sx={{ textAlign: 'center', mb: 4, width: '100%', alignItems: 'center', display: 'flex', flexDirection: 'column', justifyContent: 'center' }}>
          <Grid sx={{ mb: 4, width: { md: '800px', xs: '100%' }, mt: 6 }}>
            <Grid container alignItems="center" justifyContent="center">
              <Grid item xs={5} sx={{ display: { xs: 'none', md: 'block' } }}>
                <Box sx={{ display: 'flex', alignItems: 'center', justifyContent: 'flex-end' }}>
                  <Divider sx={{ flexGrow: 1, borderColor: 'black' }} />
                  <Box
                    sx={{
                      width: '12px',
                      height: '12px',
                      border: '2px solid #f48fb1',
                      borderRadius: '50%',
                      backgroundColor: '#ffffff',
                      marginLeft: '16px',  
                    }}
                  />
                </Box>
              </Grid>
              <Grid item xs={12} md={2}>
                <Typography variant="h6" align="center" sx={{ marginX: { xs: '8px', md: '30px' }, fontWeight: 700, fontFamily: 'sans-serif' }}>
                  Data
                </Typography>
              </Grid>
              <Grid item xs={5} sx={{ display: { xs: 'none', md: 'block' } }}>
                <Box sx={{ display: 'flex', alignItems: 'center' }}>
                  <Box
                    sx={{
                      width: '12px',
                      height: '12px',
                      border: '2px solid #f48fb1',
                      borderRadius: '50%',
                      backgroundColor: '#ffffff',
                      marginRight: '16px',
                    }}
                  />
                  <Divider sx={{ flexGrow: 1, borderColor: 'black' }} />
                </Box>
              </Grid>
            </Grid>
            <Typography variant="h6" align="center" paragraph>
              We simplify information for you on over 30,000 Colleges, 500 Exams and 500 Courses across domains and regions all over India.
            </Typography>
          </Grid>
        </Grid>
        <Grid container spacing={4} alignItems="center">
          <Grid item xs={12} md={6} >
            <Grid container spacing={4} direction="column">
              {categories.map((category) => (
                <Grid item key={category.title} sx={{marginLeft:{md:-3}}}>
                  <AnimatedCard sx={{ borderRadius: 5 }}>
                    <CustomCardContent sx={{ height: { xs: 'auto', md: '250px' } }}>
                      <Box display="flex" alignItems="center" mb={2}>
                        <IconImage src={category.icon} alt={category.title} />
                        <CustomTypography variant="h5">
                          {category.title}
                        </CustomTypography>
                      </Box>
                      <Typography variant="body1" paragraph>
                        {category.description}
                      </Typography>
                      <Box>
                        {category.items.map((item, index) => (
                          <CustomButton
                            key={index}
                            variant="outlined"
                          >
                            {item.name}
                          </CustomButton>
                        ))}
                      </Box>
                    </CustomCardContent>
                  </AnimatedCard>
                </Grid>
              ))}
            </Grid>
          </Grid>
          <Grid item xs={12} md={6} sx={{marginTop:{md:5.3}}}>
            <Box display="flex" justifyContent="center">
              <img src={Image} alt="Illustration" style={{ maxWidth: '100%', height: '100%' }} />
            </Box>
          </Grid>
        </Grid>
      </Container>
    </Grid>
  );
};

export default App;
